const PerbedaanRobot: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">🤖 Perbedaan Robot Otomatis dan Robot yang Bisa Diprogram</h2>

            <p className="mb-4">
                Sebelum kamu mulai merancang atau merakit robot pertamamu, penting untuk mengenal dua kategori dasar robot yang sering ditemukan dalam dunia robotika. Keduanya punya fungsi yang hebat, tetapi perbedaan cara kerja dan fleksibilitasnya bisa memengaruhi bagaimana kamu mendesain robotmu.
            </p>

            <h3 className="text-md font-semibold mb-2">⚙️ 1. Robot Otomatis (Fixed Logic Robot)</h3>
            <p className="mb-4">
                Robot jenis ini dirancang untuk melakukan satu tugas tertentu secara berulang dengan logika tetap (hard-coded). Artinya, robot tidak dapat belajar atau menyesuaikan perilaku tanpa perubahan hardware atau firmware. Beberapa karakteristiknya:
            </p>

            <ul className="list-disc list-inside mb-4 space-y-2">
                <li>🧠 Logika kerja bersifat statis, tidak bisa dimodifikasi setelah dipasang</li>
                <li>🔄 Sangat andal untuk tugas-tugas berulang (misalnya, menyapu pola zigzag di lantai)</li>
                <li>💸 Umumnya lebih murah karena tidak memerlukan mikrokontroler yang kompleks</li>
                <li>🧹 <strong>Contoh:</strong> Robot penyedot debu murah yang hanya bergerak maju dan belok saat menabrak dinding</li>
            </ul>

            <h3 className="text-md font-semibold mb-2">💡 2. Robot yang Bisa Diprogram (Programmable Robot)</h3>
            <p className="mb-4">
                Jenis ini jauh lebih fleksibel dan interaktif. Kamu bisa menulis kode untuk menentukan bagaimana robot bereaksi terhadap kondisi tertentu. Bahkan kamu bisa mengubah logika atau menambah fitur tanpa mengubah perangkat keras.
            </p>

            <ul className="list-disc list-inside mb-4 space-y-2">
                <li>✍️ Dapat diprogram ulang kapan saja,  cocok untuk eksperimen atau pengembangan fitur baru</li>
                <li>📚 Belajar langsung dari dunia nyata, bisa dilengkapi sensor, kamera, atau koneksi internet</li>
                <li>🎓 Sering digunakan di sekolah, lomba, atau proyek AI karena bisa belajar dan beradaptasi</li>
                <li>🛠️ <strong>Contoh:</strong> Robot berbasis Arduino atau Raspberry Pi yang dapat mengikuti garis, menghindari rintangan, bahkan mengenali wajah</li>
            </ul>

            <h3 className="text-md font-semibold mb-2">🔍 Mana yang Cocok untuk Pemula?</h3>
            <p className="mb-4">
                Jika kamu ingin belajar dasar-dasar mekanika dan melihat bagaimana robot bekerja secara langsung, robot otomatis bisa jadi awal yang baik. Tapi jika kamu tertarik dengan coding, logika, dan ingin membuat robot yang bisa bereaksi terhadap lingkungannya, robot yang bisa diprogram adalah pilihan yang sangat tepat.
            </p>

            <p className="text-gray-700">
                Memahami perbedaan ini akan membantumu memilih platform, alat, dan pendekatan yang sesuai dengan tujuan belajarmu. Jadi, ingin bikin robot yang patuh tapi statis, atau robot cerdas yang bisa kamu latih sendiri? Pilihan ada di tanganmu! 🤖💻
            </p>

        </div>

    )
}
export default PerbedaanRobot